import React from "react";
import  ReactDOM  from "react-dom";


function Skills(){
    return(

      <div id="myskills">
          <h1 className="skills-heading">Tools and Technologies</h1>
        <div className="skills">
             <div className="each-skill">
               <img className="skils-img" src="./image/java.svg"></img>
               </div>

             <div className="each-skill">
                <img className="skils-img" src="./image/javascript.svg"></img>
                </div>

             <div className="each-skill">
               <img className="skils-img" src="./image/react.svg"></img>
               </div>

             <div className="each-skill"> 
               <img className="skils-img" src="./image/nextjs.svg"></img>
               </div>

             <div className="each-skill">
               <img className="skils-img" src="./image/nodejs.svg"></img>
               </div>

             <div className="each-skill">
               <img className="skils-img" src="./image/tailwindcss.svg"></img>
               </div>

              
               <div className="each-skill">
               <img className="skils-img" src="./image/github.svg"></img>
               </div>

               <div className="each-skill">
               <img className="skils-img" src="./image/vscode.svg"></img>
               </div>
        </div>
        </div>


    );
}


export default Skills;